import { createSlice } from '@reduxjs/toolkit'

const CategoriesStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    categories: [],
    status: CategoriesStatus.LOADING,
    errorMessage: null,
}

const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        getCategoriesRequest: state => {
            state.status = CategoriesStatus.LOADING
        },
        getCategoriesRequestSuccess: (state, action) => {
            const { categories, type } = action.payload
            const newCategories = categories.map(category => {
                category.id = category.catid
                category.text = category.name
                return category
            })
            let defaultCategory
            switch (type) {
                case 'courses': {
                    defaultCategory = 'All Courses'
                    break
                }
                case 'classes': {
                    defaultCategory = 'All Classes'
                    break
                }
                default: {
                    defaultCategory = 'All Categories'
                }
            }
            state.categories = [
                {
                    text: defaultCategory,
                    id: null,
                },
                ...newCategories,
            ]
            state.status = CategoriesStatus.SUCCESS
        },
        getCategoriesRequestError: (state, action) => {
            state.errorMessage = action.payload
            state.status = CategoriesStatus.FAILURE
        },
    },
})

const {
    getCategoriesRequest,
    getCategoriesRequestSuccess,
    getCategoriesRequestError,
} = categoriesSlice.actions

export const categoriesActions = {
    getCategoriesRequest,
    getCategoriesRequestSuccess,
    getCategoriesRequestError,
}

export const categoriesSelectors = {
    isFetching: state => state.categories.status === CategoriesStatus.LOADING,
    errorMessage: state => state.categories.errorMessage,
    hasError: state => state.categories.status === CategoriesStatus.FAILURE,
    categories: state => state.categories.categories,
}

const categoriesReducer = categoriesSlice.reducer

//For intellisense
export default categoriesReducer
